<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['field_name', 'department', 'com_name', 'rank', 'writer_name', 'date']" />

    <!-- 평가 정보 -->
    <div>
      <h5 class="my-4"><i class="dot"></i> 평가 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>변호사명</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.변호사명" />
        </div>
        <div>
          <div>평가일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.평가일 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.평가일" />
        </div>
      </div>
    </div>

    <!-- 피평가자 -->
    <div>
      <h5 class="my-4"><i class="dot"></i> 피평가자</h5>
      <div class="writeGridContainer">
        <div>
          <div>업체명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.업체명 }}</p>
          <company-selector v-else :readonly="board.readonly" v-model="form.업체명" class="w-full flex-1" @select="inputCompany" />
        </div>
        <div>
          <div>수급업무</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.수급업무" />
        </div>
        <div>
          <div>인원수</div>
          <NumberInput :readonly="board.readonly" :isPrint="isPrint" v-model="form.인원수" />
        </div>
      </div>
    </div>

    <!-- 주요 검토 현황 -->
    <TableScorePercent :isPrint="isPrint" :readonly="board.readonly" title="주요 검토 현황" v-model="form.scoreDatas" @setTotal="setTotal">
      <template #cols>
        <col />
        <col width="100" />
        <col width="100" />
        <col width="100" />
        <col width="100" />
        <col width="140" />
      </template>
      <template #head>
        <tr>
          <th rowspan="2">평가지표</th>
          <th colspan="2">법적 작성 기준</th>
          <th colspan="2">기본 점수(가중치)</th>
          <th rowspan="2">평가점수</th>
        </tr>
        <tr>
          <th>주기</th>
          <th>횟수</th>
          <th>기준(배점)</th>
          <th>결과(소계)</th>
        </tr>
      </template>
      <template #body="{ data }">
        <td :colspan="data.text1 ? 1 : 6" :style="{ color: data.titleColor }">
          <span v-if="data.type !== 'title' && !data.isNoBeforeIcon" class="mr-2">•</span>
          <span v-html="data.label"></span>
        </td>
        <td v-if="typeof data.text1 === 'string'" v-html="data.text1"></td>
        <td v-if="typeof data.text1 === 'string'" v-html="data.text2"></td>
        <td v-if="typeof data.text1 === 'string'" v-html="data.text3"></td>
        <td v-if="typeof data.text1 === 'string'" v-html="data.text4"></td>
      </template>
      <template #scoreSelector="{ data, updateScore }">
        <custom-option-selector
          v-if="data.scoreType === '점수'"
          :readonly="board.readonly"
          :options="[
            { value: 100, text: '우수' },
            { value: 75, text: '양호' },
            { value: 50, text: '보통' },
            { value: 25, text: '미흡' },
            { value: 0, text: '불량' },
          ]"
          placeholder="선택(점수)"
          v-model="data.select"
          @input="updateScore($event)"
          class="w-full"
        />
        <custom-option-selector
          v-else-if="data.scoreType === '여부'"
          :readonly="board.readonly"
          :options="[
            { value: 100, text: '있음' },
            { value: 0, text: '없음' },
          ]"
          placeholder="선택(여부)"
          v-model="data.select"
          @input="updateScore($event)"
          class="w-full"
        />
        <custom-option-selector
          v-else-if="data.scoreType === '여부 R'"
          :readonly="board.readonly"
          :options="[
            { value: 100, text: '없음' },
            { value: 0, text: '있음' },
          ]"
          placeholder="선택(여부 R)"
          v-model="data.select"
          @input="updateScore($event)"
          class="w-full"
        />
        <custom-option-selector
          v-else-if="data.scoreType === '건수'"
          :readonly="board.readonly"
          :options="[
            { value: 0, text: '0건' },
            { value: 25, text: '1건 ~ 3건' },
            { value: 50, text: '4건 ~ 6건' },
            { value: 75, text: '7건 ~ 9건' },
            { value: 100, text: '10건 ~ 12건 이상' },
          ]"
          placeholder="선택(건수)"
          v-model="data.select"
          @input="updateScore($event)"
          class="w-full"
        />
        <custom-option-selector
          v-else-if="data.scoreType === '건수 R'"
          :readonly="board.readonly"
          :options="[
            { value: 100, text: '0건' },
            { value: 75, text: '1건 ~ 3건' },
            { value: 50, text: '4건 ~ 6건' },
            { value: 25, text: '7건 ~ 9건' },
            { value: 0, text: '10건 이상' },
          ]"
          placeholder="선택(건수 R)"
          v-model="data.select"
          @input="updateScore($event)"
          class="w-full"
        />
      </template>
    </TableScorePercent>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import CompanySelector from "@/components/selector/CompanySelector";
import TableScorePercent from "@/components/TableScorePercent.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelectorObject";

import ScoreTableData from "./ScoreTableData";

export default {
  components: {
    CompanySelector,
    TableScorePercent,
    CustomOptionSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        변호사명: "",
        평가일: "",
        업체명: "",
        업체명_name: "",
        수급업무: "",
        인원수: "",

        scoreDatas: JSON.parse(JSON.stringify(ScoreTableData)),
        scoreTotal: null,

        photoList: [],
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    inputCompany(value) {
      this.form.업체명_name = value.com_name;
    },
    setTotal(value) {
      this.form.scoreTotal = value;
    },
  },
};
</script>
